import { render, staticRenderFns } from "./ItsOrderOutBound.vue?vue&type=template&id=0f04c9ee&scoped=true&"
import script from "./ItsOrderOutBound.vue?vue&type=script&lang=js&"
export * from "./ItsOrderOutBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04c9ee",
  null
  
)

export default component.exports